import fetchApi from "../fetchApi";
export const unlockUser = async (id) => {

    const options = {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/json'
        }),
        redirect: 'follow'
    }

    return await fetchApi(`users/${id}/unlock`, options);
};
